import { DisplayConditionsDialog } from "../../screens/HtmlCampaign/components/ContentDialogs";

export const ClientFields = [
  {
    value: "FirstName",
    label: "common.first_name"
  },
  {
    value: "LastName",
    label: "common.last_name"
  },
  {
    value: "Cellphone",
    label: "common.cellphone"
  },
  {
    value: "Email",
    label: "common.email"
  },
  {
    value: "Telephone",
    label: "common.telephone"
  },
  {
    value: "Address",
    label: "common.address"
  },
  {
    value: "City",
    label: "common.city"
  },
  {
    value: "State",
    label: "common.state"
  },
  {
    value: "Country",
    label: "common.country"
  },
  {
    value: "Zip",
    label: "common.zip"
  },
  {
    value: "Company",
    label: "common.company"
  },
  {
    value: "BirthDate",
    label: "common.birth_date"
  },
  {
    value: "ReminderDate",
    label: "common.reminder_date"
  },
];

export const LoyaltyPersonalizationFields = [
  { value: "loyalty_points", label: "campaigns.loyalty.points" },
  { value: "loyalty_tier", label: "campaigns.loyalty.tier" },
  { value: "loyalty_points_earned", label: "campaigns.loyalty.pointsEarned" },
  { value: "loyalty_tier_multiplier", label: "campaigns.loyalty.tierMultiplier" },
  { value: "loyalty_points_expiry", label: "campaigns.loyalty.pointsExpiry" },
];

export const LangugeCode = [
  {
    value: 0,
    label: "languages.langCodes.hebrew"
  },
  {
    value: 1,
    label: "languages.langCodes.english"
  },
  {
    value: 2,
    label: "languages.langCodes.french"
  },
  {
    value: 3,
    label: "languages.langCodes.spanish"
  },
  {
    value: 4,
    label: "languages.langCodes.german"
  },
  {
    value: 5,
    label: "languages.langCodes.russian"
  },
  {
    value: 6,
    label: "languages.langCodes.japaneese"
  },
  {
    value: 7,
    label: "languages.langCodes.romana"
  },
  {
    value: 8,
    label: "languages.langCodes.arabic"
  },
  {
    value: 9,
    label: "languages.langCodes.hungarian"
  },
  {
    value: 10,
    label: "languages.langCodes.slovak"
  },
  {
    value: 11,
    label: "languages.langCodes.portuguese"
  },
  {
    value: 12,
    label: "languages.langCodes.dutch"
  },
  {
    value: 14,
    label: "languages.langCodes.polish"
  }
]

export const MobileSupport = [
  {
    value: 0,
    label: "common.adaptive"
  },
  {
    value: 1,
    label: "common.responsive"
  }
];

export const PulseemFolderType = {
  CLIENT_IMAGES: 0,
  DOCUMENT: 1
}

export const PulseemFeatures = {
  LOCK_SENDING: '1',
  SUB_ACCOUNTS: '2',
  TARGETS: '3',
  AUTO_TIMING_SEND: '4',
  CAMPAIGN_TEMPLATES: '5',
  OPTIN: '6',
  SMS: '7',
  GOOGLE_LINKS: '8',
  FUTURE: '9',
  INMAIL_IMAGES: '10',
  CLIENT_HTML_SCRIPT: '11',
  LANDING_PAGES: '12',
  LOCK_EXPORT_DATA: '13',
  FILE_ATTACHMENT: '14',
  SIMPLY_CLUB: '15',
  MANUAL_INPUT_SEND: '16',
  MULTI_GROUP_DELETE: '17',
  PULSEEM_KOSHER: '18',
  ADD_CAMPAIGN_LINK_2_SMS: '19',
  CAMPAIGN_TOPICS: '20',
  SMS_RESPONSE: '21',
  SYNCHRONIZE_REGULAR_AND_DIRECT_CLIENT_STATUSES: '22',
  SMS_LINKS_STATISTICS: '24',
  UNSUBSCRIBEEMAILFEATURE: '25',
  UNSUBSCRIBESMSFEATURE: '26',
  LOGIN_IP_CHECK: '27',
  REMOVE_CLIENTS: '28',
  CATALOGUE: '29',
  UNSUBSCRIBE: '30',
  FLASH_SMS: '31',
  AUTOMATION: '32',
  SMPP_DLR_ONLY: '33',
  PREPAID_FROM_WS: '34',
  NOTIFICATION: '35',
  OLD_PAGES: '36',
  PURCHASE_NEWSLETTER_PACKAGES: '37',
  ADD_SMS_REMOVE_TEXT: '38',
  REMOVE_SMS_UNSUBSCRIBE_LINK: '39',
  OTPSUGGESTION: '40',
  BEE_EDITOR: '41',
  REVENUE: '42',
  BEE_AMP: '43',
  BEE_ENABLE_GOOGLE_FONTS: '44',
  DISABLE_TWO_FACTOR_AUTH: '45',
  WHATSAPP: '46',
  NEW_EMAIL_KOSHER: '47',
  DISABLED_PENDING_EMAIL_OTP: '48',
  UI_API: '49',
  DIRECT_API: '50',
  NOT_TO_SHOW_CREDITS_HISTORY_FEATURE: '51',
  ALLOW_EURO_PAYMENT: '52',
  HIDE_SHARED_DOMAIN: '53',
  ALLOW_HIDDEN_UNSUBSCRIBE_LINK: '54',
  DISABLE_OPTIN_PLUGIN: '56',
  AUTOMATION_TEMPLATE: '57',
  SHOW_OLD_API_CREDENTIAL: '58',
  AFFILIATE: '59',
  WhatsAppOnboardingVirtualNumbers: '61',
  DisableTermOfUse: '62',
  DuplicateOldCampaignToBee: '63',
  NewAPIEmailKosher: '64',
  WhatsNew: '65',
  MMS: '66',
  PolishLangMenu: '67',
  NewsletterAI: '68',
  PolyAIAgent: '69',
  Popup: '70',
  PolyAISupport: '73',
  DisplayConditions: '74',
  DATA_SOURCES: '76',
  // CLAL CENTER (מרכז כלל) — the agent-portal CMS. '77' verified free in THIS numbering, which is
  // the cookie-backed AccountFeatures list and NOT FeatureTierCode (where 77 is taken). The client
  // gates on this flag only; the server gates on the ClalCenter.AllowedSubAccountID appSetting.
  CLAL_CENTER: '77'
}